import Drawer, { Props as DrawerProps } from '../../../../components/Drawer';
import TileDrawerStepper from '../../../shared/TileDrawerStepper';
import DrawerHeader from '../DrawerHeader';
import TimerSteps, { Steps } from '../TimerSteps';

export interface TimerDrawerProps extends Pick<DrawerProps, 'open' | 'onClose'> {}

export const TimerDrawer = ({ open, onClose }: TimerDrawerProps) => {
  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <TileDrawerStepper header={<DrawerHeader />} steps={Steps}>
        {({ currentStep, goToNextStep }) => <TimerSteps currentStep={currentStep} goToNextStep={goToNextStep} />}
      </TileDrawerStepper>
    </Drawer>
  );
};

export default TimerDrawer;
